import { render } from "./AssetOverview.vue?vue&type=template&id=88d99e3e&scoped=true"
import script from "./AssetOverview.vue?vue&type=script&lang=js"
export * from "./AssetOverview.vue?vue&type=script&lang=js"

import "./AssetOverview.vue?vue&type=style&index=0&id=88d99e3e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88d99e3e"]])

export default __exports__